import React, { useState, useRef, useEffect } from 'react'
import { Row, Col } from '@deere/ux.uxframe-react'
import { Button } from "@deere/fuel-react"
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, Redirect } from "react-router-dom";
import ActionsReviewSurvey from '../components/buttons/ActionsReviewSurvey'
import CustomAlert from '../components/CustomAlert';
import SectionPage from './SectionPage'
import LaborReviewSection from '../components/review/LaborReviewSection'
import BsReviewSection from '../components/review/BsReviewSection'
import OfpReviewSection from '../components/review/OfpReviewSection'
import CapacityReviewSection from '../components/review/CapacityReviewSection'
import FlexibilityReviewSection from '../components/review/FlexibilityReviewSection'
import AdditionalCommentsReviewSection from '../components/review/AditionalCommentsReviewSection'
import Tier2ReviewSection from '../components/review/Tier2ReviewSection'
import Tier2ReviewIndirectSection from '../components/review/Tier2ReviewIndirectSection'
import FutureConsiderationReviewSection from '../components/review/FutureConsiderationReviewSection'
import CtpatAgreementPopUp from '../components/modals/CtpatAgreementPopUp'
import { submitSurvey, submitSurveyExt } from '../services/campaign.service';
import { setCampaign } from '../redux/action/campaignAction'
import { useOktaAuth } from '@okta/okta-react'
import { useUserInfo } from '../providers/userProvider'
import { FLEXIBILITY_SECTION_NAME, SCBM_INDIRECT_SECCION_CODES, SCBM_CODE, CRS_REQUEST_STATUS_OBJ, CTPAT, SCBM_INDIRECT, FUTURE_CONSIDERATIONS_SECTION_INDIRECT, AEU} from '../utils/surveyLiterals'
import { LABOR_SECTION_NAME_INDIRECT, CAPACITY_CONSTRAINT_SECTION_INDIRECT, TIER_LABOR_NAME_INDIRECT,SCBM_SECCIO_CODES, OS, NON_OKTA_USER } from '../utils/surveyLiterals'
import { ReactComponent as PrintIcon } from '@deere/ux.brand-foundations/icons/print.svg';
import { useTranslation } from "react-i18next"; 
import { getDateFromTimeStamp } from "../utils/utils"
import { getSurveyResponse } from '../services/survey.service';
import { useCampaign } from '../hooks/useCampaign';
import OSSectionPage from "./os/OSSectionPage";
import { ERR_DESC_REQUEST_NUMBER, ERR_TITLE_REQUEST_NUMBER } from "../utils/errorLiterals";
import CyberSecurityReviewSection from '../components/review/CyberSecurityReviewSection';
import OtherReviewSection from '../components/review/OtherReviewSection';
import { ModalGeneric } from '../components/ModalGeneric';
import { ModalSubmit } from '../components/ModalSubmit';

export default function ReviewPage(props) {
    const { t } = useTranslation();
    const userInfo = useUserInfo();
    const { authState } = useOktaAuth();
    const location = useLocation();
    const dispatch = useDispatch()
    const [statusSaved, setStatusSaved] = useState(undefined);
    const [survey] = useState(location.state.survey);
    const [answers, setAnswers] = useState([]);
    const [genericAnswer, setGenericAnswer] = useState([]);
    const sections = survey.sections.sort((a, b) => (a.id > b.id) ? 1 : -1)
    const flSection = sections.find(e => e.code === SCBM_SECCIO_CODES.FL)
    const acSection = sections.find(e => e.code === SCBM_SECCIO_CODES.AC)
    const bsSection = sections.find(e => e.code === SCBM_SECCIO_CODES.BS)
    const laSection = sections.find(e => e.code === SCBM_SECCIO_CODES.LB)
    const ofSection = sections.find(e => e.code === SCBM_SECCIO_CODES.OF)
    const ccSection = sections.find(e => e.code === SCBM_SECCIO_CODES.CC)
    const t2Section = sections.find(e => e.code === SCBM_SECCIO_CODES.T2)
    const csSection = sections.find(e => e.code === SCBM_SECCIO_CODES.CS);
    const othSection = sections.find(e => e.code === SCBM_SECCIO_CODES.OTH);
    const laSectionIndirect = sections.find(e => e.description === LABOR_SECTION_NAME_INDIRECT)
    const ccSectionIndirect = sections.find(e => e.description === CAPACITY_CONSTRAINT_SECTION_INDIRECT)
    const flSectionIndirect = sections.find(e => e.description === FLEXIBILITY_SECTION_NAME)
    const t2SectionIndirect = sections.find(e => e.description === TIER_LABOR_NAME_INDIRECT)
    const fcSectionIndirect = sections.find(e => e.description === FUTURE_CONSIDERATIONS_SECTION_INDIRECT)
    const bsSectionIndirect = sections.find(e => e.code === SCBM_INDIRECT_SECCION_CODES.BS)

    let sectionsTitles = [...sections.map((section) => section.description)]
    const sectionsRef = useRef([new Array(sectionsTitles.length)]);
    const [showAgreement, setShowAgreement] = useState(false);
    const [campaignAssig, setCampaignAssig] = useState(undefined);
    const [rn, setRn] = useState(undefined);
    const campaign = useCampaign();
    const answersFromRedux = useSelector(state => state.survey.surveyAnswers);
    const genericAnswerFromRedux = useSelector(state => state.genericSurvey.surveyAnswersForm[survey.code]);
    const osContactsFromRedux = useSelector(state => state.genericSurvey.osContactForm);
    const [osContact, setOSContact] = useState([]);
    const [showAEUDisclaimer, setShowAEUDisclaimer] = useState(false);
    const [showSubmitModal, setShowSubmitModal] = useState(false);
  
    let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
    let nonOktaAuthFailed = !isAuthMethodOkta ? (location.state && location.state.isAuthNonOkta ? false : true) : false;
    let token = isAuthMethodOkta ? authState.accessToken.accessToken : "";

    useEffect(() => {
        if (window.location.pathname === "/reviewext") props.setShowHeaderFooter(false);
      }, []);

    useEffect(() => {
        const setRequestNumber = async () => {
            if (location.state.previous !== "/details" && Array.isArray(campaignAssig) && campaignAssig.length > 0) {
                setRn(campaignAssig[0].id)
            } else {
                setRn(location.state.rn);
            }
        }
        const fetchSurveyAnswers = async () => {
            if (campaign) {
                setCampaignAssig(campaign);
                getSurveyResponse(campaign, null, token, isAuthMethodOkta)
                    .then(response => {
                        if (response && Array.isArray(response.surveyAnswers)) {
                            setAnswers(response.surveyAnswers);
                            setGenericAnswer(response.surveyAnswers);
                            setOSContact(response.ownershipContact);
                        } else {
                            setAnswers(!Array.isArray(answersFromRedux) ? [] : answersFromRedux);
                            setGenericAnswer(!Array.isArray(genericAnswerFromRedux) ? [] : genericAnswerFromRedux);
                            setOSContact(!Array.isArray(osContactsFromRedux) ? [] : osContactsFromRedux);
                        }
                    }).catch(ex => {
                        console.log(ex);
                        setAnswers(!Array.isArray(answersFromRedux) ? [] : answersFromRedux);
                        setGenericAnswer(!Array.isArray(genericAnswerFromRedux) ? [] : genericAnswerFromRedux);
                        setOSContact(!Array.isArray(osContactsFromRedux) ? [] : osContactsFromRedux);
                    })
            }
        }

        setRequestNumber();
        fetchSurveyAnswers();

    }, [campaign])

    const setStatusSubmit = (message) => {
        let statusResponse = { ...message };
        setStatusSaved(statusResponse);
    }


    function handlePrint() {
        window.print();
    }

    const subTitleUpdatedBy = () => {
        let respondedBy = "";
        let respondedOn = "";
        if(location.state.updatedByName){
            respondedBy = location.state.updatedByName;
        }
        if(location.state.updatedTs){
            respondedOn = getDateFromTimeStamp(new Date(location.state.updatedTs));
        }
        if(respondedBy === ""){
            if(Array.isArray(location.state.campaign.assignmentUpdateDetails) && location.state.campaign.assignmentUpdateDetails.length > 0){
                const assignment = location.state.campaign.assignmentUpdateDetails.find((asgn) => asgn.id === rn);
                if(assignment){
                    respondedBy = assignment.updatedBy ? assignment.updatedBy : "";
                    respondedOn = assignment.updatedTs ? getDateFromTimeStamp(new Date(assignment.updatedTs)) : "";
                }
            }else if(campaignAssig && Array.isArray(campaignAssig.assignments) && campaignAssig.assignments.length > 0){
                const assignment = campaignAssig.assignments[0]
                if(assignment && assignment.updatedTs){
                    respondedBy = assignment.updatedBy ? assignment.updatedBy : "";
                    respondedOn = assignment.updatedTs ? getDateFromTimeStamp(new Date(assignment.updatedTs)) : "";
                }
            }
        }
        let strSaved = location.state.status === CRS_REQUEST_STATUS_OBJ.COMPLETE ? 'Responded' : 'Last saved';
        if (respondedBy !== "" && respondedOn !== "") {
          return <h5>{`${strSaved} by ${respondedBy} on ${respondedOn}`}</h5>;
        } else if (respondedBy !== "") {
          return <h5>{`${strSaved} by ${respondedBy}`}</h5>;
        } else if(respondedOn !== ""){
          return <h5>{`${strSaved} on ${respondedOn}`}</h5>;
        } else {
          return "";
        }
      };

    const surveyTitle = () => {
        const dueDate = getDateFromTimeStamp(campaignAssig && campaignAssig.endDate ? campaignAssig.endDate : "");
        const supplierNumber = campaign && Array.isArray(campaign.assignments) && campaign.assignments.length > 0 && campaign.assignments[0].supplierNumber ? campaign.assignments[0].supplierNumber : "";
        const supplierName =
          location && location.state && location.state.supplierName && location.state.supplierName.includes(supplierNumber)
            ? location.state.supplierName
            : `${supplierNumber} - ${location.state.supplierName}`;
        if (location.state) {
          return (
            <Col xs={24} md={24}>
              <Row>
                <Col xs={24} md={24}>
                  <h1>{location.state.surveyType}</h1>
                </Col>
              </Row>
              <Row>
                <Col xs={20} md={21}>
                  <h5>{rn ? `Current request ${rn} - ${supplierName}` : supplierName}</h5>
                  <h5>Due date {dueDate} </h5>
                  {subTitleUpdatedBy()}
                </Col>
                <Col xs={3} md={3} style={{ textAlign: "right", display: "flex", alignItems: "flex-end" }}>
                  <Button variant="secondary" className="d-print-none" onClick={handlePrint}>
                    <PrintIcon size="sm" />
                    {t("rev_print")}
                  </Button>
                </Col>
              </Row>
            </Col>
          );
        }
        return null;
    };

    const handleClose = () => setShowAgreement(false);

    const submitSurveyFn = () => {

        let tmp = { ...campaignAssig };
        tmp.assignments[0].status = CRS_REQUEST_STATUS_OBJ.COMPLETE;
        tmp.assignments[0].updatedBy = userInfo ? userInfo.userID : NON_OKTA_USER;
        if (!tmp.updatedBy) {
            delete tmp.updatedBy
        }

        try {
            if(isAuthMethodOkta){
                submitSurvey(tmp, token).then((camp) => {
                    setCampaignAssig(camp);
                    dispatch(setCampaign(camp));
                    window.scrollTo(0, 0);
                    setShowSubmitModal(true);
                })
            }else{
                submitSurveyExt(tmp).then((camp) => {
                    setCampaignAssig(camp);
                    dispatch(setCampaign(camp));
                    window.scrollTo(0, 0);
                    setShowSubmitModal(true);
                })
            }
        } catch (error) {
            console.log(error);
            setStatusSubmit({ status: true, message: error, label: 'Danger:', variant: 'danger' });
            window.scrollTo(0, 0);
        }
    }

    const shouldSectionRender = (section) => {
        let shouldRender = true;
        if (!genericAnswer || genericAnswer.length === 0) {// Case where user has not started working on survey yet - show all 
            return shouldRender;
        }
        let depDetails = section && section.sectionDependency && Array.isArray(section.sectionDependency) ? section.sectionDependency : [];
        for (let i = 0; i < depDetails.length; i++) {
            shouldRender = false;
            let answersAvailable = genericAnswer && genericAnswer.length > 0 ? genericAnswer : [];
            if (answersAvailable.length > 0) {
                let depAnswer = answersAvailable.find((ans) => ans.questionId === depDetails[i].idQuestionDependson);
                if (depAnswer && depAnswer.answer === depDetails[i].idSelectionDependson.toString()) {
                    shouldRender = true;
                    break;
                }
            }
        }
        return shouldRender;
    }

    const kindReview = (code) => {
        if (code === SCBM_CODE) {
            return <Col>
                {
                    bsSection ? <> <BsReviewSection sectionSurvey={bsSection} answers={answers} /> <br /></> : <></>
                }
                {
                    laSection ? <> <LaborReviewSection sectionSurvey={laSection} answers={answers} /> <br /></> : <></>
                }
                {
                    ofSection ? <> <OfpReviewSection sectionSurvey={ofSection} answers={answers} /> <br /></> : <></>
                }
                {
                    ccSection ? <> <CapacityReviewSection sectionSurvey={ccSection} answers={answers} /> <br /></> : <></>
                }
                {
                    flSection ? <> <FlexibilityReviewSection sectionSurvey={flSection} answers={answers} /> <br /></> : <></>
                }
                {
                    t2Section ? <> <Tier2ReviewSection sectionSurvey={t2Section} answers={answers} /> <br /></> : <></>
                }
                {
                    acSection ? <> <AdditionalCommentsReviewSection sectionSurvey={acSection} answers={answers} /> <br /></> : <></>
                }
                {
                    csSection ? <> <CyberSecurityReviewSection sectionSurvey={csSection} answers={answers} /> <br /></> : <></>
                }
                {
                    othSection ? <> <OtherReviewSection sectionSurvey={othSection} answers={answers} /> <br /></> : <></>
                }
            </Col>
        } else if (code === SCBM_INDIRECT) {
            return <Col>
                {
                    bsSectionIndirect ? <> <BsReviewSection sectionSurvey={bsSectionIndirect} answers={answers} /> <br /></> : null
                }
                {
                    laSectionIndirect ? <> <LaborReviewSection sectionSurvey={laSectionIndirect} answers={answers} /> <br /></> : null
                }
                {
                    ccSectionIndirect ? <> <CapacityReviewSection sectionSurvey={ccSectionIndirect} answers={answers} /> <br /></> : null
                }
                {
                    flSectionIndirect ? <> <FlexibilityReviewSection sectionSurvey={flSectionIndirect} answers={answers} /> <br /></> : null
                }
                {
                    t2SectionIndirect ? <> <Tier2ReviewIndirectSection sectionSurvey={t2SectionIndirect} answers={answers} /> <br /></> : null
                }
                {
                    fcSectionIndirect ? <> <FutureConsiderationReviewSection sectionSurvey={fcSectionIndirect} answers={answers} /> <br /></> : null
                }
            </Col>
        } else {
            return <>
                <Col xs={24} md={24}>
                    {
                        sections.map((section, index) => {
                            return shouldSectionRender(section) ?
                                <div key={index}>
                                    <div ref={el => sectionsRef.current[index] = el}>
                                        {code === OS ? (
                                            <OSSectionPage section={section} survey={survey} review={true} answers={genericAnswer} ownershipContact={osContact}/>
                                            ) : (
                                            <SectionPage section={section} survey={survey} review={true} answers={genericAnswer} />
                                        )}
                                    </div>
                                    <br />
                                </div>
                                :
                                <></>
                        })
                    }
                </Col>
            </>
        }
    }

    if (!isAuthMethodOkta && nonOktaAuthFailed) {
        return (
            <Redirect
                to={{
                    pathname: "/error",
                    state: { errorTitle: ERR_TITLE_REQUEST_NUMBER, errorDescription: ERR_DESC_REQUEST_NUMBER },
                }}
            />
        );
    }

    return (<div>
        <Row>
            {surveyTitle()}
        </Row>
        <Row>
            {
                statusSaved && statusSaved.status ?
                    <Col><CustomAlert accessibilityLabel={statusSaved.label} variant={statusSaved.variant} title={statusSaved.message} /></Col>
                    : null
            }
        </Row>
        <Row>
            {kindReview(survey.code)}
        </Row>
        <ActionsReviewSurvey setStatusSubmit={setStatusSubmit} setShowAgreement={setShowAgreement} survey={survey} campaign={campaign}
            submitSurveyFn={submitSurveyFn} campaignAssig={campaignAssig} rn={rn} answers={answers} setShowAEUDisclaimer={setShowAEUDisclaimer}/>
        {survey.code === CTPAT && <CtpatAgreementPopUp showAgreement={showAgreement} handleClose={handleClose}
            submitSurvey={submitSurveyFn} survey={survey} />}
        {survey.code === AEU && (
            <ModalGeneric
            showModal={showAEUDisclaimer}
            setShowModal={setShowAEUDisclaimer}
            labelBtnPrimary={t("confirm_label")}
            labelBtnSecondary={t("btn_cancel")}
            handleSubmit={()=>{
                submitSurveyFn();
                setShowAEUDisclaimer(false);
            }}
            msgModal={t("aeu_disclaimer_msg")}
            titleModal={t("aeu_survey_submit_title")}
            />
        )}
        <ModalSubmit
            showModal={showSubmitModal}
            setShowModal={setShowSubmitModal}
            titleKey={"survey_submit_modal_title"}
            messageKey={"submit_popup_message"}
            doNotNavidate={!isAuthMethodOkta}
            buttonKey={"btn_OK"}
        />
    </div>)
}
